import { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'
import { displayDate } from 'shared/libs/dayjs/helpers'
import { apiDateFormat, localDateFormat } from 'shared/libs/dayjs/model'
import { useAppSearchParams } from 'shared/libs/hooks/useAppSearchParams'
import { CommonQuery } from 'shared/types/QueryModel'

import RangePicker from 'shared/ui/Form/RangePicker'

import './FilterRangePicker.css'

interface Props extends RangePickerProps {
  onRangePickerChange?: (value: any) => void
  withPage?: boolean
}

const FilterRangePicker = ({
  onRangePickerChange,
  withPage = false,
  className,
  ...props
}: Props) => {
  const { getAllParams, setParams, deleteKeys } = useAppSearchParams()

  const { start_date, end_date } = getAllParams()

  const handleChange = (dates: any) => {
    const datesParams = [
      {
        key: 'start_date' as keyof CommonQuery,
        value: displayDate(dates[0], apiDateFormat),
      },
      {
        key: 'end_date' as keyof CommonQuery,
        value: displayDate(dates[1], apiDateFormat),
      },
    ]
    if (dates) {
      setParams(
        withPage ? [...datesParams, { key: 'page', value: '1' }] : datesParams,
      )
    } else {
      deleteKeys(['start_date', 'end_date'])
    }

    if (onRangePickerChange) onRangePickerChange(dates)
  }

  return (
    <RangePicker
      onChange={handleChange}
      className={`customFilterRangePicker ${className}`}
      value={[
        start_date ? dayjs(start_date) : null,
        end_date ? dayjs(end_date) : null,
      ]}
      format={localDateFormat}
      {...props}
    />
  )
}

export default FilterRangePicker
